/**
 * Typo transform
 */
export var TypographyTransform;
(function (TypographyTransform) {
    TypographyTransform["TEXT_CAPITALIZED"] = "is-capitalized";
    TypographyTransform["TEXT_LOWERCASE"] = "is-lowercase";
    TypographyTransform["TEXT_UPPERCASE"] = "is-uppercase";
    TypographyTransform["TEXT_ITALIC"] = "is-italic";
})(TypographyTransform || (TypographyTransform = {}));
//# sourceMappingURL=TypographyTransform.js.map